import { Injectable } from '@angular/core';
import { InAppReview } from '@capacitor-community/in-app-review';
import { Capacitor } from '@capacitor/core';

import { ILogger, LoggerService } from '../logging';

@Injectable({ providedIn: 'root' })
export class InAppReviewService {
  private logger: ILogger;
  constructor(loggerService: LoggerService) {
    this.logger = loggerService.getLogger('InAppReviewService');
  }

  async askReview() {
    if (Capacitor.isNativePlatform()) {
      try {
        this.logger.info('Asking for review');
        await InAppReview.requestReview();
      } catch (err) {
        this.logger.error('Error while calling requestReview ', { err });
      }
    }
  }
}
